import Component from 'can/component/component';
import template from './featured-slider.stache';
import Swiper from 'swiper';

Component.extend({
    tag: 'featured-slider',
    template: template,
    viewModel: {
        define: {
            data: {
                type: 'object',
                value: null,
            },
            currentItem: {
                type: 'string',
            },
            swiperConfig: {
                type: 'object',
                value: {},
            },
            isSwiperBeginning: {
                type: 'boolean',
                value: true,
            },
            isSwiperEnd: {
                type: 'boolean',
                value: false,
            },
            isNavVisible: {
                get() {
                    return this.attr('data') && this.attr('data').length >= 4;
                },
            },
        },
    },
    events: {
        inserted() {
            this.initSwiper();
        },

        initSwiper() {
            this.swiper = new Swiper(
                this.element.find('.js-swiper-container'),
                {
                    spaceBetween: 20,
                    slidesPerView: 'auto',
                    centerInsufficientSlides: true,
                    on: {
                        progress: (progress) => {
                            this.viewModel.attr('isSwiperEnd', progress >= 1);
                            this.viewModel.attr(
                                'isSwiperBeginning',
                                progress <= 0,
                            );
                        },
                    },
                    navigation: {
                        nextEl: this.element.find('.js-button-next'),
                        prevEl: this.element.find('.js-button-prev'),
                    },
                },
            );
        },
    },
});
